import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

interface NoRowsContentStyledProps {
  isError?: boolean;
}

export const NoRowsContentStyled = styled('div')<NoRowsContentStyledProps>(
  ({ isError }) => ({
    borderRadius: 8,
    border: `1px solid ${isError ? Colors.red500 : Colors.gray300}`,
    padding: 32,
    textAlign: 'center',

    '.MuiTypography-root': {
      color: isError ? Colors.red500 : undefined,
    },
  })
);
